import styled from 'styled-components';
export const ImgBanner = styled.img`
  width: 100%;

  @media (max-width: 800px) {
    display: none !important;
  }
`;

export const ImgBannerResp = styled.img`
  display: none !important;
  width: 100%;

  @media (max-width: 800px) {
    display: block !important;
  }
`;
